import { QueryClient } from '@tanstack/react-query';
import { createRetryFn, standardRetryDelay } from './retryPolicy';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: createRetryFn(),
      retryDelay: standardRetryDelay,
    },
    mutations: {
      retry: createRetryFn({ maxRetries: 0 }),
      retryDelay: standardRetryDelay,
    },
  },
});
